export enum TechnicalReportStatusEnum {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
}

export const getTechnicalReportStatusLabel = (type: TechnicalReportStatusEnum): string => {
  switch (type) {
    case TechnicalReportStatusEnum.ACTIVE:
      return "Pendiente";
    case TechnicalReportStatusEnum.COMPLETED:
      return "Completado";
  }
};

export const getTechnicalReportStatusOptions = (): { label: string; value: string }[] =>
  Object.keys(TechnicalReportStatusEnum).map((val) => {
    const value = TechnicalReportStatusEnum[val as keyof typeof TechnicalReportStatusEnum];
    return { label: getTechnicalReportStatusLabel(value), value: value, translate: true };
  });
